// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"home-module--mainDiv--1ZVwu","homeHeading":"home-module--homeHeading--1TFEq"};